import { Card, Col, Grid, Image, Row, Typography } from 'antd';

import classes from './index.module.less';

const KomunitasSect3Container = () => {
	const { xs } = Grid.useBreakpoint();
	return (
		<div className={classes.pagehero}>
			<div className="container" style={{ paddingBottom: '25px' }}>
				<Typography className={classes.paragraph} style={{ fontWeight: 500 }}>
					Perjalanan komunitas kami
				</Typography>
				<h2 className={classes.title}>
					Dari WA group ke <span className={classes.netralcolor}> platform sendiri</span>
				</h2>
				<div className={classes.compareSection}>
					<Row align="middle" justify="center" gutter={[16, 16]}>

						{/* LEFT CARD */}
						<Col xs={24} md={9}>
							<Card className={`${classes.cardFixed} ${classes.cardLeft}`}>
								<h3 style={{color: '#4A4545'}}>Dulu - WA Group</h3>
								<ul style={{ marginLeft: '-20px', color:'#A19797' }}>
									<li>Chat mudah tertumpuk</li>
									<li>Diskusi tidak terstruktur</li>
									<li>Notifikasi rame, bikin pusing</li>
									<li>Komunitas tersebar di banyak grup</li>
								</ul>
							</Card>
						</Col>

						{/* CENTER IMAGE */}
						<Col xs={0} md={6} className={classes.centerImage}>
							<div className={classes.line} />

							<div className={classes.imageWrapper}>
								{
									xs ?
										''
										:
										<Image
											src="/images/komunitas/komunitasSect3.svg"
											alt="image-section-3"
											preview={false}
										/>
								}
							</div>
						</Col>
						<Col xs={24} md={0} className={classes.lineMobile}>
							<div className={classes.line} />
						</Col>

						{/* RIGHT CARD */}
						<Col xs={24} md={9}>
							<Card className={`${classes.cardFixed} ${classes.cardRight}`}>
								<h3 style={{color: '#4A4545'}}>
									Sekarang - <span className={classes.netralcolor}>Di Aplikasi</span>
								</h3>
								<ul style={{ marginLeft: '-20px', color:'#4A4545' }}>
									<li>Format postingan seperti X / Threads</li>
									<li>Filter topik sesuai kebutuhan Mama</li>
									<li>Bisa curhat dan cerita tanpa menampilkan identitas</li>
									<li>Komunitas lengkap, semua topik ada</li>
								</ul>
							</Card>
						</Col>

					</Row>
				</div>
			</div>
		</div>
	);
};

export default KomunitasSect3Container;
